import { render } from "./CreatePalletSimulation.vue?vue&type=template&id=345a8082&ts=true"
import script from "./CreatePalletSimulation.vue?vue&type=script&lang=ts"
export * from "./CreatePalletSimulation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__